import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';
import { cn } from '../../utils/cn';

interface StatCardProps {
  icon: LucideIcon;
  title: string;
  value: string | number;
  change?: string;
  progress?: number;
  color: string;
  showProgress?: boolean;
}

const StatCard = ({ 
  icon: Icon, 
  title, 
  value, 
  change, 
  progress = 0, 
  color,
  showProgress
}: StatCardProps) => {
  return (
    <div className="bg-white rounded-lg border p-4 flex flex-col h-full min-h-[100px]">
      <div className="flex items-center gap-3 flex-grow">
        <div className={cn(
          "w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0",
          color === 'bg-blue-500' ? 'bg-blue-50' : 
          color === 'bg-orange-500' ? 'bg-orange-50' : 
          color === 'bg-red-500' ? 'bg-red-50' : 
          color === 'bg-green-500' ? 'bg-green-50' : 
          color === 'bg-purple-500' ? 'bg-purple-50' : 'bg-gray-50'
        )}>
          <Icon className={cn(
            "w-5 h-5",
            color === 'bg-blue-500' ? 'text-blue-600' : 
            color === 'bg-orange-500' ? 'text-orange-600' : 
            color === 'bg-red-500' ? 'text-red-600' : 
            color === 'bg-green-500' ? 'text-green-600' : 
            color === 'bg-purple-500' ? 'text-purple-600' : 'text-gray-600'
          )} />
        </div>

        <div className="min-w-0 flex-grow">
          <h3 className="text-sm text-gray-600 mb-1 min-h-[1.25rem] line-clamp-1">{title}</h3>
          <div className="text-xl text-gray-900 font-semibold">{value}</div>
        </div>
      </div>

      {(showProgress !== undefined ? showProgress : Number(value) > 0) && (
        <div className="mt-auto pt-3 w-full">
          <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
            <div 
              className={cn(
                "h-full rounded-full transition-all duration-500",
                color
              )}
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default StatCard;